import React from 'react';

import { IPaymentMethodOptionItemProps } from 'payments/components/payment-method-option-item/payment-method-option-item';
import { PaymentMethodOptionItemPaypal } from 'payments/components/payment-method-option-item/payment-method-option-item-paypal';

export const PaypalCheckoutDotComOptionItem: React.FC<IPaymentMethodOptionItemProps> = props => {
  const { paymentId, ...restProps } = props;

  return <PaymentMethodOptionItemPaypal paymentId={paymentId} {...restProps} />;
};
